import React from 'react';
import { LeadTimeAlertLevel } from '@models/warehouse.model';
import { getAlertColors } from '@utils/leadTime';
import { formatDateOnly } from '@utils/formatDate';

interface LeadTimeBadgeProps {
  alertLevel: LeadTimeAlertLevel | null;
  daysUntilDeadline: number;
  orderByDate: Date;
}

export const LeadTimeBadge: React.FC<LeadTimeBadgeProps> = ({
  alertLevel,
  daysUntilDeadline,
  orderByDate,
}) => {
  if (!alertLevel) return null;

  const colors = getAlertColors(alertLevel);

  let label: string;
  if (alertLevel === 'OVERDUE') {
    label = `Overdue by ${Math.abs(daysUntilDeadline)} day${Math.abs(daysUntilDeadline) !== 1 ? 's' : ''}`;
  } else if (alertLevel === 'URGENT') {
    label = daysUntilDeadline === 0
      ? 'Order today'
      : `Order within ${daysUntilDeadline} day${daysUntilDeadline !== 1 ? 's' : ''}`;
  } else {
    label = `Order by ${formatDateOnly(orderByDate)}`;
  }

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${colors.bg} ${colors.text}`}
    >
      {label}
    </span>
  );
};

export default LeadTimeBadge;
